/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./types";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const isEmailAvailable = /* GraphQL */ `query IsEmailAvailable($email: String!) {
  isEmailAvailable(email: $email)
}
` as GeneratedQuery<
  APITypes.IsEmailAvailableQueryVariables,
  APITypes.IsEmailAvailableQuery
>;
export const getLead = /* GraphQL */ `query GetLead($id: ID!) {
  getLead(id: $id) {
    id
    stored_at
    lead_source
    first_name
    last_name
    email
    phone
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLeadQueryVariables, APITypes.GetLeadQuery>;
export const getCurrentReferralCampaign = /* GraphQL */ `query GetCurrentReferralCampaign {
  getCurrentReferralCampaign {
    start_date
    end_date
    referrer_amount
    referee_amount
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCurrentReferralCampaignQueryVariables,
  APITypes.GetCurrentReferralCampaignQuery
>;
export const getReferralCampaign = /* GraphQL */ `query GetReferralCampaign($date: String!) {
  getReferralCampaign(date: $date) {
    start_date
    end_date
    referrer_amount
    referee_amount
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReferralCampaignQueryVariables,
  APITypes.GetReferralCampaignQuery
>;
export const listReferralCampaigns = /* GraphQL */ `query ListReferralCampaigns($count: Int, $nextToken: String) {
  listReferralCampaigns(count: $count, nextToken: $nextToken) {
    items {
      start_date
      end_date
      referrer_amount
      referee_amount
      name
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReferralCampaignsQueryVariables,
  APITypes.ListReferralCampaignsQuery
>;
export const getInvestorAccount = /* GraphQL */ `query GetInvestorAccount($id: ID!) {
  getInvestorAccount(id: $id) {
    id
    name
    email
    email_verified_at
    email2
    phone
    phone2
    address
    address2
    city
    state
    zip
    country
    status
    individual_details {
      account_type
      first_name
      last_name
      dob
      middle_name
      owners_accredited
      total_assets
      __typename
    }
    employment {
      employment_status
      occupation
      employer
      employer_address
      employer_address2
      employer_city
      employer_state
      employer_zip
      __typename
    }
    domicile
    needs_manual_kyc_aml_review
    manual_kyc_aml_review {
      photo_id_front_file {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      photo_id_back_file {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      submitted_at
      completed_at
      __typename
    }
    accreditation {
      started_at
      accredited_on
      method
      status
      docusign_details {
        signer_name
        signer_email
        __typename
      }
      hellosign_details {
        signer_name
        signer_email
        __typename
      }
      __typename
    }
    accreditation_self {
      status
      created_at
      accredited_at
      reason_annual_income
      reason_net_worth
      reason_certification
      reason_employment
      __typename
    }
    accreditation_hellosign {
      status
      created_at
      accredited_at
      signature_details {
        signer_name
        signer_email
        __typename
      }
      __typename
    }
    accreditation_manual {
      status
      created_at
      accredited_at
      __typename
    }
    accredited_survey {
      date_submitted
      __typename
    }
    non_accredited_survey {
      date_submitted
      __typename
    }
    non_accredited_survey_v2 {
      completed_at
      broker_dealer_assoc {
        updated_at
        value
        __typename
      }
      annual_income {
        updated_at
        value
        __typename
      }
      net_worth {
        updated_at
        value
        __typename
      }
      objective {
        updated_at
        value
        __typename
      }
      pct_liquid_securities {
        updated_at
        value
        __typename
      }
      pct_illiquid_securities {
        updated_at
        value
        __typename
      }
      time_horizon {
        updated_at
        value
        __typename
      }
      risk_profile {
        updated_at
        value
        __typename
      }
      experience {
        experience_stocks {
          updated_at
          value
          __typename
        }
        experience_bonds {
          updated_at
          value
          __typename
        }
        experience_re {
          updated_at
          value
          __typename
        }
        experience_alts {
          updated_at
          value
          __typename
        }
        migrated {
          updated_at
          value
          __typename
        }
        __typename
      }
      employment {
        employment_status
        occupation {
          updated_at
          value
          __typename
        }
        employer {
          updated_at
          value
          __typename
        }
        employer_address {
          updated_at
          value
          __typename
        }
        employer_address2 {
          updated_at
          value
          __typename
        }
        employer_city {
          updated_at
          value
          __typename
        }
        employer_state {
          updated_at
          value
          __typename
        }
        employer_zip {
          updated_at
          value
          __typename
        }
        __typename
      }
      __typename
    }
    claims_is_accredited
    has_bd_account
    aml_date
    aml_status
    kyc_status
    kyc_aml {
      passed_aml
      passed_kyc
      __typename
    }
    created_at
    created_ip_address
    pending_trades {
      id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      principal
      created_at
      opened_at
      is_drip
      redemption {
        requested_amount
        redeem_all
        requested_date
        __typename
      }
      scheduled_closing_at
      settled_at
      status
      shares
      share_price
      type
      auto_invest {
        day
        __typename
      }
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      principal_suitability_approval {
        approved_by
        updated_at
        approval_status
        snooze_until
        __typename
      }
      goal_id
      __typename
    }
    was_invited
    rr_suitability_approval {
      approved_by
      approved_at
      updated_at
      approval_status
      snooze_until
      __typename
    }
    rr_suitability_notes {
      created_at
      author
      note
      __typename
    }
    referral_program {
      enrolled_at
      referral_count
      rewards_earned
      branch_link
      referrer_name
      referee_amount
      referee_completed_at
      __typename
    }
    rewards_balance
    tally_dividends
    tally_rewards_earned
    tally_rewards_applied
    is_name_locked
    promos {
      code
      name
      start_date
      end_date
      __typename
    }
    pricing_plan
    accepted_tc_at
    unaccepted_agreements
    partner {
      partner_id
      name
      style {
        primary_logo {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        secondary_logo {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        bg_color
        html
        __typename
      }
      __typename
    }
    hints {
      code
      status
      severity
      text
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvestorAccountQueryVariables,
  APITypes.GetInvestorAccountQuery
>;
export const getConsolidatedInvestor = /* GraphQL */ `query GetConsolidatedInvestor($id: ID!) {
  getConsolidatedInvestor(id: $id) {
    account_value {
      pending_value
      settled_value
      total_value
      __typename
    }
    acc_value {
      pending_value
      settled_value
      total_value
      __typename
    }
    balance_history {
      changed_on
      balance
      __typename
    }
    bank_accounts {
      id
      name
      account_type
      account_number
      created_at
      default
      status
      ins_name
      plaid_ins_id
      plaid_reauth_required
      __typename
    }
    dividends {
      recent_dividends {
        amount
        issued_at
        period
        rewards_applied
        __typename
      }
      months {
        amount
        issued_at
        period
        rewards_applied
        __typename
      }
      __typename
    }
    investor {
      id
      name
      email
      email_verified_at
      email2
      phone
      phone2
      address
      address2
      city
      state
      zip
      country
      status
      individual_details {
        account_type
        first_name
        last_name
        dob
        middle_name
        owners_accredited
        total_assets
        __typename
      }
      employment {
        employment_status
        occupation
        employer
        employer_address
        employer_address2
        employer_city
        employer_state
        employer_zip
        __typename
      }
      domicile
      needs_manual_kyc_aml_review
      manual_kyc_aml_review {
        photo_id_front_file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        photo_id_back_file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        submitted_at
        completed_at
        __typename
      }
      accreditation {
        started_at
        accredited_on
        method
        status
        docusign_details {
          signer_name
          signer_email
          __typename
        }
        hellosign_details {
          signer_name
          signer_email
          __typename
        }
        __typename
      }
      accreditation_self {
        status
        created_at
        accredited_at
        reason_annual_income
        reason_net_worth
        reason_certification
        reason_employment
        __typename
      }
      accreditation_hellosign {
        status
        created_at
        accredited_at
        signature_details {
          signer_name
          signer_email
          __typename
        }
        __typename
      }
      accreditation_manual {
        status
        created_at
        accredited_at
        __typename
      }
      accredited_survey {
        date_submitted
        __typename
      }
      non_accredited_survey {
        date_submitted
        __typename
      }
      non_accredited_survey_v2 {
        completed_at
        broker_dealer_assoc {
          updated_at
          value
          __typename
        }
        annual_income {
          updated_at
          value
          __typename
        }
        net_worth {
          updated_at
          value
          __typename
        }
        objective {
          updated_at
          value
          __typename
        }
        pct_liquid_securities {
          updated_at
          value
          __typename
        }
        pct_illiquid_securities {
          updated_at
          value
          __typename
        }
        time_horizon {
          updated_at
          value
          __typename
        }
        risk_profile {
          updated_at
          value
          __typename
        }
        experience {
          experience_stocks {
            updated_at
            value
            __typename
          }
          experience_bonds {
            updated_at
            value
            __typename
          }
          experience_re {
            updated_at
            value
            __typename
          }
          experience_alts {
            updated_at
            value
            __typename
          }
          migrated {
            updated_at
            value
            __typename
          }
          __typename
        }
        employment {
          employment_status
          occupation {
            updated_at
            value
            __typename
          }
          employer {
            updated_at
            value
            __typename
          }
          employer_address {
            updated_at
            value
            __typename
          }
          employer_address2 {
            updated_at
            value
            __typename
          }
          employer_city {
            updated_at
            value
            __typename
          }
          employer_state {
            updated_at
            value
            __typename
          }
          employer_zip {
            updated_at
            value
            __typename
          }
          __typename
        }
        __typename
      }
      claims_is_accredited
      has_bd_account
      aml_date
      aml_status
      kyc_status
      kyc_aml {
        passed_aml
        passed_kyc
        __typename
      }
      created_at
      created_ip_address
      pending_trades {
        id
        subscription_offer {
          id
          listed_at
          slug
          name
          display_name
          entity_name
          description
          offering_id
          status
          auto_invest_doc_v2_id
          auto_invest_doc_v2 {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          documents {
            title
            url
            show_on_listing
            show_on_checkout
            __typename
          }
          current_apy
          expected_return
          regulatory_rule_type
          offer_type
          asset_class
          investor_count {
            settled
            pending
            total
            __typename
          }
          subscription_doc {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          raised_amount {
            settled
            pending
            total
            __typename
          }
          funding_limit
          target_amount
          require_whole_shares
          min_invest_amount
          max_invest_amount
          share_price
          suggested_invest_amounts
          leverage_pct
          non_accredited_slots_full
          sfr {
            documents {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            offering_breakdown {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            volatility
            info {
              address
              city
              state
              zip
              baths
              beds
              description
              electricity
              gas_type
              headline
              images {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              lat_long {
                lat
                long
                __typename
              }
              lot_size
              name
              nearby_employers {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              nearby_schools {
                description
                name
                number_of_reviews
                link
                review_rating
                students
                __typename
              }
              nearby_stores {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              septic
              sewer
              sqft
              tags
              water
              year
              __typename
            }
            market_data {
              projected_dividend_yield
              dividend_yield_historical_average
              dividend_yield_national_average
              dividend_yield_link
              projected_equity_rate
              equity_historical_average
              equity_national_average
              equity_link
              summary
              __typename
            }
            status {
              status
              road_map {
                step
                description
                __typename
              }
              tenant_leasing {
                link
                data {
                  description
                  highlight
                  title
                  link
                  image {
                    url
                    title
                    description
                    link
                    file {
                      bucket
                      key
                      region
                      download_url
                      upload_url
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              updates {
                date
                title
                description
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          total_shares
          auto_invest_doc_id
          auto_invest_doc {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          hints
          __typename
        }
        principal
        created_at
        opened_at
        is_drip
        redemption {
          requested_amount
          redeem_all
          requested_date
          __typename
        }
        scheduled_closing_at
        settled_at
        status
        shares
        share_price
        type
        auto_invest {
          day
          __typename
        }
        rr_suitability_approval {
          approved_by
          approved_at
          updated_at
          approval_status
          snooze_until
          __typename
        }
        principal_suitability_approval {
          approved_by
          updated_at
          approval_status
          snooze_until
          __typename
        }
        goal_id
        __typename
      }
      was_invited
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      rr_suitability_notes {
        created_at
        author
        note
        __typename
      }
      referral_program {
        enrolled_at
        referral_count
        rewards_earned
        branch_link
        referrer_name
        referee_amount
        referee_completed_at
        __typename
      }
      rewards_balance
      tally_dividends
      tally_rewards_earned
      tally_rewards_applied
      is_name_locked
      promos {
        code
        name
        start_date
        end_date
        __typename
      }
      pricing_plan
      accepted_tc_at
      unaccepted_agreements
      partner {
        partner_id
        name
        style {
          primary_logo {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          secondary_logo {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          bg_color
          html
          __typename
        }
        __typename
      }
      hints {
        code
        status
        severity
        text
        __typename
      }
      __typename
    }
    referral_campaign {
      start_date
      end_date
      referrer_amount
      referee_amount
      name
      __typename
    }
    referrals {
      name
      created_at
      completed_at
      amount
      __typename
    }
    trades {
      id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      principal
      created_at
      opened_at
      is_drip
      redemption {
        requested_amount
        redeem_all
        requested_date
        __typename
      }
      scheduled_closing_at
      settled_at
      status
      shares
      share_price
      type
      auto_invest {
        day
        __typename
      }
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      principal_suitability_approval {
        approved_by
        updated_at
        approval_status
        snooze_until
        __typename
      }
      goal_id
      __typename
    }
    transactions {
      id
      subscription_offer_id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      posted_at
      amount
      waived_amount
      code
      title
      description
      dividend_detail {
        rewards_applied
        base_yield
        total_yield
        __typename
      }
      __typename
    }
    user_profile {
      user_id
      first_name
      last_name
      username
      headshot_url
      headshot {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      friend {
        status
        is_requester
        created_at
        accepted_at
        __typename
      }
      signature_file {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      branch_link
      has_initial_branch_data
      app_prefs {
        viewed_intro
        __typename
      }
      __typename
    }
    auto_invests {
      investor_account_id
      autoinvest_id
      subscription_offer_id
      created_at
      start_date
      amount
      frequency
      interval
      days_of_month
      days_of_week
      is_disabled
      goal_id
      __typename
    }
    goals {
      investor_account_id
      goal_id
      goal_type
      name
      start_date
      target_date
      target_value
      target_monthly_income
      color
      icon
      current_value
      is_advised
      calculated_monthly_amount
      is_on_track
      __typename
    }
    subscription_offer {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    subscription {
      auto_invest_signature {
        method
        signed_at
        internalsign_details {
          id
          user_id
          investor_account_id
          signed_at
          user_full_name
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        __typename
      }
      subscription_offer_id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      signature {
        method
        sent_at
        signed_at
        __typename
      }
      total_shares
      cost_basis
      tally_primary_cost
      tally_dividends
      tally_drip_cost
      share_price
      value {
        pending_value
        settled_value
        total_value
        __typename
      }
      __typename
    }
    subscriptions {
      auto_invest_signature {
        method
        signed_at
        internalsign_details {
          id
          user_id
          investor_account_id
          signed_at
          user_full_name
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        __typename
      }
      subscription_offer_id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      signature {
        method
        sent_at
        signed_at
        __typename
      }
      total_shares
      cost_basis
      tally_primary_cost
      tally_dividends
      tally_drip_cost
      share_price
      value {
        pending_value
        settled_value
        total_value
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConsolidatedInvestorQueryVariables,
  APITypes.GetConsolidatedInvestorQuery
>;
export const allInvestorAccountApplications = /* GraphQL */ `query AllInvestorAccountApplications($count: Int, $nextToken: String) {
  allInvestorAccountApplications(count: $count, nextToken: $nextToken) {
    items {
      id
      user_id
      status
      claims_is_accredited
      email
      email2
      phone
      phone2
      address
      address2
      city
      state
      zip
      country
      domicile
      individual_details {
        account_type
        first_name
        last_name
        dob
        middle_name
        owners_accredited
        total_assets
        __typename
      }
      partner_id
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllInvestorAccountApplicationsQueryVariables,
  APITypes.AllInvestorAccountApplicationsQuery
>;
export const getAccreditedSurvey = /* GraphQL */ `query GetAccreditedSurvey($investor_account_id: ID!) {
  getAccreditedSurvey(investor_account_id: $investor_account_id) {
    questions {
      question
      description
      answer {
        type
        boolean
        choice {
          label
          __typename
        }
        choices {
          labels
          other
          __typename
        }
        number
        text
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccreditedSurveyQueryVariables,
  APITypes.GetAccreditedSurveyQuery
>;
export const getNonAccreditedSurvey = /* GraphQL */ `query GetNonAccreditedSurvey($investor_account_id: ID!) {
  getNonAccreditedSurvey(investor_account_id: $investor_account_id) {
    questions {
      question
      description
      answer {
        type
        boolean
        choice {
          label
          __typename
        }
        choices {
          labels
          other
          __typename
        }
        number
        text
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNonAccreditedSurveyQueryVariables,
  APITypes.GetNonAccreditedSurveyQuery
>;
export const getInvestorAccountApplication = /* GraphQL */ `query GetInvestorAccountApplication($id: ID!) {
  getInvestorAccountApplication(id: $id) {
    id
    user_id
    status
    claims_is_accredited
    email
    email2
    phone
    phone2
    address
    address2
    city
    state
    zip
    country
    domicile
    individual_details {
      account_type
      first_name
      last_name
      dob
      middle_name
      owners_accredited
      total_assets
      __typename
    }
    partner_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvestorAccountApplicationQueryVariables,
  APITypes.GetInvestorAccountApplicationQuery
>;
export const getTotalPrincipalBalance = /* GraphQL */ `query GetTotalPrincipalBalance($investor_account_id: ID!) {
  getTotalPrincipalBalance(investor_account_id: $investor_account_id)
}
` as GeneratedQuery<
  APITypes.GetTotalPrincipalBalanceQueryVariables,
  APITypes.GetTotalPrincipalBalanceQuery
>;
export const allOfferings = /* GraphQL */ `query AllOfferings($count: Int, $nextToken: String) {
  allOfferings(count: $count, nextToken: $nextToken) {
    items {
      id
      property_type
      share_price
      target_hold_months
      title
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllOfferingsQueryVariables,
  APITypes.AllOfferingsQuery
>;
export const getOffering = /* GraphQL */ `query GetOffering($id: ID!) {
  getOffering(id: $id) {
    id
    property_type
    share_price
    target_hold_months
    title
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOfferingQueryVariables,
  APITypes.GetOfferingQuery
>;
export const listDividendRates = /* GraphQL */ `query ListDividendRates($offering_id: ID!, $count: Int, $nextToken: String) {
  listDividendRates(
    offering_id: $offering_id
    count: $count
    nextToken: $nextToken
  ) {
    items {
      start_date
      end_date
      rate
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDividendRatesQueryVariables,
  APITypes.ListDividendRatesQuery
>;
export const getReferrals = /* GraphQL */ `query GetReferrals($investor_account_id: ID!) {
  getReferrals(investor_account_id: $investor_account_id) {
    items {
      name
      created_at
      completed_at
      amount
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReferralsQueryVariables,
  APITypes.GetReferralsQuery
>;
export const allRewards = /* GraphQL */ `query AllRewards($investor_account_id: ID!, $count: Int, $next_token: String) {
  allRewards(
    investor_account_id: $investor_account_id
    count: $count
    next_token: $next_token
  ) {
    items {
      id
      posted_at
      amount
      description
      code
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllRewardsQueryVariables,
  APITypes.AllRewardsQuery
>;
export const allSubscriptionOffers = /* GraphQL */ `query AllSubscriptionOffers($count: Int, $nextToken: String) {
  allSubscriptionOffers(count: $count, nextToken: $nextToken) {
    items {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllSubscriptionOffersQueryVariables,
  APITypes.AllSubscriptionOffersQuery
>;
export const listSubscriptionOffers = /* GraphQL */ `query ListSubscriptionOffers(
  $investor_account_id: ID
  $asset_class: AssetClass
) {
  listSubscriptionOffers(
    investor_account_id: $investor_account_id
    asset_class: $asset_class
  ) {
    items {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionOffersQueryVariables,
  APITypes.ListSubscriptionOffersQuery
>;
export const adminListSubscriptionOffers = /* GraphQL */ `query AdminListSubscriptionOffers($asset_class: AssetClass) {
  adminListSubscriptionOffers(asset_class: $asset_class) {
    items {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminListSubscriptionOffersQueryVariables,
  APITypes.AdminListSubscriptionOffersQuery
>;
export const getSubscriptionOffer = /* GraphQL */ `query GetSubscriptionOffer($id: ID!) {
  getSubscriptionOffer(id: $id) {
    id
    listed_at
    slug
    name
    display_name
    entity_name
    description
    offering_id
    status
    auto_invest_doc_v2_id
    auto_invest_doc_v2 {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    documents {
      title
      url
      show_on_listing
      show_on_checkout
      __typename
    }
    current_apy
    expected_return
    regulatory_rule_type
    offer_type
    asset_class
    investor_count {
      settled
      pending
      total
      __typename
    }
    subscription_doc {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    raised_amount {
      settled
      pending
      total
      __typename
    }
    funding_limit
    target_amount
    require_whole_shares
    min_invest_amount
    max_invest_amount
    share_price
    suggested_invest_amounts
    leverage_pct
    non_accredited_slots_full
    sfr {
      documents {
        link
        data {
          description
          highlight
          title
          link
          image {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      offering_breakdown {
        link
        data {
          description
          highlight
          title
          link
          image {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      volatility
      info {
        address
        city
        state
        zip
        baths
        beds
        description
        electricity
        gas_type
        headline
        images {
          url
          title
          description
          link
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        lat_long {
          lat
          long
          __typename
        }
        lot_size
        name
        nearby_employers {
          url
          title
          description
          link
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        nearby_schools {
          description
          name
          number_of_reviews
          link
          review_rating
          students
          __typename
        }
        nearby_stores {
          url
          title
          description
          link
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        septic
        sewer
        sqft
        tags
        water
        year
        __typename
      }
      market_data {
        projected_dividend_yield
        dividend_yield_historical_average
        dividend_yield_national_average
        dividend_yield_link
        projected_equity_rate
        equity_historical_average
        equity_national_average
        equity_link
        summary
        __typename
      }
      status {
        status
        road_map {
          step
          description
          __typename
        }
        tenant_leasing {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        updates {
          date
          title
          description
          image {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    total_shares
    auto_invest_doc_id
    auto_invest_doc {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    hints
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionOfferQueryVariables,
  APITypes.GetSubscriptionOfferQuery
>;
export const getSubscriptionOfferV2 = /* GraphQL */ `query GetSubscriptionOfferV2($id: ID, $slug: String, $investor_account_id: ID) {
  getSubscriptionOfferV2(
    id: $id
    slug: $slug
    investor_account_id: $investor_account_id
  ) {
    id
    listed_at
    slug
    name
    display_name
    entity_name
    description
    offering_id
    status
    auto_invest_doc_v2_id
    auto_invest_doc_v2 {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    documents {
      title
      url
      show_on_listing
      show_on_checkout
      __typename
    }
    current_apy
    expected_return
    regulatory_rule_type
    offer_type
    asset_class
    investor_count {
      settled
      pending
      total
      __typename
    }
    subscription_doc {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    raised_amount {
      settled
      pending
      total
      __typename
    }
    funding_limit
    target_amount
    require_whole_shares
    min_invest_amount
    max_invest_amount
    share_price
    suggested_invest_amounts
    leverage_pct
    non_accredited_slots_full
    sfr {
      documents {
        link
        data {
          description
          highlight
          title
          link
          image {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      offering_breakdown {
        link
        data {
          description
          highlight
          title
          link
          image {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      volatility
      info {
        address
        city
        state
        zip
        baths
        beds
        description
        electricity
        gas_type
        headline
        images {
          url
          title
          description
          link
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        lat_long {
          lat
          long
          __typename
        }
        lot_size
        name
        nearby_employers {
          url
          title
          description
          link
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        nearby_schools {
          description
          name
          number_of_reviews
          link
          review_rating
          students
          __typename
        }
        nearby_stores {
          url
          title
          description
          link
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        septic
        sewer
        sqft
        tags
        water
        year
        __typename
      }
      market_data {
        projected_dividend_yield
        dividend_yield_historical_average
        dividend_yield_national_average
        dividend_yield_link
        projected_equity_rate
        equity_historical_average
        equity_national_average
        equity_link
        summary
        __typename
      }
      status {
        status
        road_map {
          step
          description
          __typename
        }
        tenant_leasing {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        updates {
          date
          title
          description
          image {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    total_shares
    auto_invest_doc_id
    auto_invest_doc {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    hints
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionOfferV2QueryVariables,
  APITypes.GetSubscriptionOfferV2Query
>;
export const getSubscription = /* GraphQL */ `query GetSubscription($investor_account_id: ID!, $subscription_offer_id: ID!) {
  getSubscription(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
  ) {
    auto_invest_signature {
      method
      signed_at
      internalsign_details {
        id
        user_id
        investor_account_id
        signed_at
        user_full_name
        file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        __typename
      }
      __typename
    }
    subscription_offer_id
    subscription_offer {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    signature {
      method
      sent_at
      signed_at
      __typename
    }
    total_shares
    cost_basis
    tally_primary_cost
    tally_dividends
    tally_drip_cost
    share_price
    value {
      pending_value
      settled_value
      total_value
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubscriptionQueryVariables,
  APITypes.GetSubscriptionQuery
>;
export const listSubscriptions = /* GraphQL */ `query ListSubscriptions($investor_account_id: ID!) {
  listSubscriptions(investor_account_id: $investor_account_id) {
    auto_invest_signature {
      method
      signed_at
      internalsign_details {
        id
        user_id
        investor_account_id
        signed_at
        user_full_name
        file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        __typename
      }
      __typename
    }
    subscription_offer_id
    subscription_offer {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    signature {
      method
      sent_at
      signed_at
      __typename
    }
    total_shares
    cost_basis
    tally_primary_cost
    tally_dividends
    tally_drip_cost
    share_price
    value {
      pending_value
      settled_value
      total_value
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubscriptionsQueryVariables,
  APITypes.ListSubscriptionsQuery
>;
export const allTrades = /* GraphQL */ `query AllTrades($investor_account_id: ID!, $count: Int, $nextToken: String) {
  allTrades(
    investor_account_id: $investor_account_id
    count: $count
    nextToken: $nextToken
  ) {
    items {
      id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      principal
      created_at
      opened_at
      is_drip
      redemption {
        requested_amount
        redeem_all
        requested_date
        __typename
      }
      scheduled_closing_at
      settled_at
      status
      shares
      share_price
      type
      auto_invest {
        day
        __typename
      }
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      principal_suitability_approval {
        approved_by
        updated_at
        approval_status
        snooze_until
        __typename
      }
      goal_id
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<APITypes.AllTradesQueryVariables, APITypes.AllTradesQuery>;
export const getAccountValue = /* GraphQL */ `query GetAccountValue($investor_account_id: ID!) {
  getAccountValue(investor_account_id: $investor_account_id) {
    pending_value
    settled_value
    total_value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountValueQueryVariables,
  APITypes.GetAccountValueQuery
>;
export const getAccountValueV2 = /* GraphQL */ `query GetAccountValueV2($investor_account_id: ID!) {
  getAccountValueV2(investor_account_id: $investor_account_id) {
    pending_value
    settled_value
    total_value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountValueV2QueryVariables,
  APITypes.GetAccountValueV2Query
>;
export const getBalanceHistory = /* GraphQL */ `query GetBalanceHistory($investor_account_id: ID!) {
  getBalanceHistory(investor_account_id: $investor_account_id) {
    items {
      changed_on
      balance
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBalanceHistoryQueryVariables,
  APITypes.GetBalanceHistoryQuery
>;
export const getTrade = /* GraphQL */ `query GetTrade($id: ID!) {
  getTrade(id: $id) {
    id
    subscription_offer {
      id
      listed_at
      slug
      name
      display_name
      entity_name
      description
      offering_id
      status
      auto_invest_doc_v2_id
      auto_invest_doc_v2 {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      documents {
        title
        url
        show_on_listing
        show_on_checkout
        __typename
      }
      current_apy
      expected_return
      regulatory_rule_type
      offer_type
      asset_class
      investor_count {
        settled
        pending
        total
        __typename
      }
      subscription_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      raised_amount {
        settled
        pending
        total
        __typename
      }
      funding_limit
      target_amount
      require_whole_shares
      min_invest_amount
      max_invest_amount
      share_price
      suggested_invest_amounts
      leverage_pct
      non_accredited_slots_full
      sfr {
        documents {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        offering_breakdown {
          link
          data {
            description
            highlight
            title
            link
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        volatility
        info {
          address
          city
          state
          zip
          baths
          beds
          description
          electricity
          gas_type
          headline
          images {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          lat_long {
            lat
            long
            __typename
          }
          lot_size
          name
          nearby_employers {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          nearby_schools {
            description
            name
            number_of_reviews
            link
            review_rating
            students
            __typename
          }
          nearby_stores {
            url
            title
            description
            link
            file {
              bucket
              key
              region
              download_url
              upload_url
              __typename
            }
            __typename
          }
          septic
          sewer
          sqft
          tags
          water
          year
          __typename
        }
        market_data {
          projected_dividend_yield
          dividend_yield_historical_average
          dividend_yield_national_average
          dividend_yield_link
          projected_equity_rate
          equity_historical_average
          equity_national_average
          equity_link
          summary
          __typename
        }
        status {
          status
          road_map {
            step
            description
            __typename
          }
          tenant_leasing {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          updates {
            date
            title
            description
            image {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      total_shares
      auto_invest_doc_id
      auto_invest_doc {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      hints
      __typename
    }
    principal
    created_at
    opened_at
    is_drip
    redemption {
      requested_amount
      redeem_all
      requested_date
      __typename
    }
    scheduled_closing_at
    settled_at
    status
    shares
    share_price
    type
    auto_invest {
      day
      __typename
    }
    rr_suitability_approval {
      approved_by
      approved_at
      updated_at
      approval_status
      snooze_until
      __typename
    }
    principal_suitability_approval {
      approved_by
      updated_at
      approval_status
      snooze_until
      __typename
    }
    goal_id
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTradeQueryVariables, APITypes.GetTradeQuery>;
export const allTransactionsV2 = /* GraphQL */ `query AllTransactionsV2(
  $investor_account_id: ID!
  $count: Int
  $nextToken: String
) {
  allTransactionsV2(
    investor_account_id: $investor_account_id
    count: $count
    nextToken: $nextToken
  ) {
    items {
      id
      subscription_offer_id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      posted_at
      amount
      waived_amount
      code
      title
      description
      dividend_detail {
        rewards_applied
        base_yield
        total_yield
        __typename
      }
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllTransactionsV2QueryVariables,
  APITypes.AllTransactionsV2Query
>;
export const allAutoInvestSchedulesV2 = /* GraphQL */ `query AllAutoInvestSchedulesV2(
  $investor_account_id: ID!
  $subscription_offer_id: ID
  $nextToken: String
) {
  allAutoInvestSchedulesV2(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
    nextToken: $nextToken
  ) {
    items {
      investor_account_id
      autoinvest_id
      subscription_offer_id
      created_at
      start_date
      amount
      frequency
      interval
      days_of_month
      days_of_week
      is_disabled
      goal_id
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllAutoInvestSchedulesV2QueryVariables,
  APITypes.AllAutoInvestSchedulesV2Query
>;
export const getAutoInvestScheduleV2 = /* GraphQL */ `query GetAutoInvestScheduleV2($investor_account_id: ID!, $autoinvest_id: ID!) {
  getAutoInvestScheduleV2(
    investor_account_id: $investor_account_id
    autoinvest_id: $autoinvest_id
  ) {
    investor_account_id
    autoinvest_id
    subscription_offer_id
    created_at
    start_date
    amount
    frequency
    interval
    days_of_month
    days_of_week
    is_disabled
    goal_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutoInvestScheduleV2QueryVariables,
  APITypes.GetAutoInvestScheduleV2Query
>;
export const allMyUserInvestorRoles = /* GraphQL */ `query AllMyUserInvestorRoles($count: Int, $nextToken: String) {
  allMyUserInvestorRoles(count: $count, nextToken: $nextToken) {
    items {
      investor_id
      user_id
      role
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllMyUserInvestorRolesQueryVariables,
  APITypes.AllMyUserInvestorRolesQuery
>;
export const getInvestorAccountUploadURL = /* GraphQL */ `query GetInvestorAccountUploadURL(
  $investor_account_id: ID!
  $filename: String
  $content_type: String
) {
  getInvestorAccountUploadURL(
    investor_account_id: $investor_account_id
    filename: $filename
    content_type: $content_type
  ) {
    bucket
    key
    region
    download_url
    upload_url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvestorAccountUploadURLQueryVariables,
  APITypes.GetInvestorAccountUploadURLQuery
>;
export const getBankAccounts = /* GraphQL */ `query GetBankAccounts($investor_account_id: ID!) {
  getBankAccounts(investor_account_id: $investor_account_id) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBankAccountsQueryVariables,
  APITypes.GetBankAccountsQuery
>;
export const getDefaultBankAccount = /* GraphQL */ `query GetDefaultBankAccount($investor_account_id: ID!) {
  getDefaultBankAccount(investor_account_id: $investor_account_id) {
    id
    name
    account_type
    account_number
    created_at
    default
    status
    ins_name
    plaid_ins_id
    plaid_reauth_required
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDefaultBankAccountQueryVariables,
  APITypes.GetDefaultBankAccountQuery
>;
export const allDividendsV3 = /* GraphQL */ `query AllDividendsV3($investor_account_id: ID!) {
  allDividendsV3(investor_account_id: $investor_account_id) {
    recent_dividends {
      amount
      issued_at
      period
      rewards_applied
      __typename
    }
    months {
      amount
      issued_at
      period
      rewards_applied
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllDividendsV3QueryVariables,
  APITypes.AllDividendsV3Query
>;
export const getBranchLink = /* GraphQL */ `query GetBranchLink {
  getBranchLink
}
` as GeneratedQuery<
  APITypes.GetBranchLinkQueryVariables,
  APITypes.GetBranchLinkQuery
>;
export const getMyProfile = /* GraphQL */ `query GetMyProfile($user_id: ID!) {
  getMyProfile(user_id: $user_id) {
    user_id
    first_name
    last_name
    username
    headshot_url
    headshot {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    friend {
      status
      is_requester
      created_at
      accepted_at
      __typename
    }
    signature_file {
      bucket
      key
      region
      download_url
      upload_url
      __typename
    }
    branch_link
    has_initial_branch_data
    app_prefs {
      viewed_intro
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMyProfileQueryVariables,
  APITypes.GetMyProfileQuery
>;
export const getProfile = /* GraphQL */ `query GetProfile($friend_id: ID!) {
  getProfile(friend_id: $friend_id) {
    id
    first_name
    last_name
    username
    headshot_url
    headshot {
      download_url
      __typename
    }
    friend {
      status
      is_requester
      created_at
      accepted_at
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProfileQueryVariables,
  APITypes.GetProfileQuery
>;
export const tradesPendingApproval = /* GraphQL */ `query TradesPendingApproval($filter: TradesApprovalFilter) {
  tradesPendingApproval(filter: $filter) {
    trade {
      id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      principal
      created_at
      opened_at
      is_drip
      redemption {
        requested_amount
        redeem_all
        requested_date
        __typename
      }
      scheduled_closing_at
      settled_at
      status
      shares
      share_price
      type
      auto_invest {
        day
        __typename
      }
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      principal_suitability_approval {
        approved_by
        updated_at
        approval_status
        snooze_until
        __typename
      }
      goal_id
      __typename
    }
    investor_account {
      id
      name
      email
      email_verified_at
      email2
      phone
      phone2
      address
      address2
      city
      state
      zip
      country
      status
      individual_details {
        account_type
        first_name
        last_name
        dob
        middle_name
        owners_accredited
        total_assets
        __typename
      }
      employment {
        employment_status
        occupation
        employer
        employer_address
        employer_address2
        employer_city
        employer_state
        employer_zip
        __typename
      }
      domicile
      needs_manual_kyc_aml_review
      manual_kyc_aml_review {
        photo_id_front_file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        photo_id_back_file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        submitted_at
        completed_at
        __typename
      }
      accreditation {
        started_at
        accredited_on
        method
        status
        docusign_details {
          signer_name
          signer_email
          __typename
        }
        hellosign_details {
          signer_name
          signer_email
          __typename
        }
        __typename
      }
      accreditation_self {
        status
        created_at
        accredited_at
        reason_annual_income
        reason_net_worth
        reason_certification
        reason_employment
        __typename
      }
      accreditation_hellosign {
        status
        created_at
        accredited_at
        signature_details {
          signer_name
          signer_email
          __typename
        }
        __typename
      }
      accreditation_manual {
        status
        created_at
        accredited_at
        __typename
      }
      accredited_survey {
        date_submitted
        __typename
      }
      non_accredited_survey {
        date_submitted
        __typename
      }
      non_accredited_survey_v2 {
        completed_at
        broker_dealer_assoc {
          updated_at
          value
          __typename
        }
        annual_income {
          updated_at
          value
          __typename
        }
        net_worth {
          updated_at
          value
          __typename
        }
        objective {
          updated_at
          value
          __typename
        }
        pct_liquid_securities {
          updated_at
          value
          __typename
        }
        pct_illiquid_securities {
          updated_at
          value
          __typename
        }
        time_horizon {
          updated_at
          value
          __typename
        }
        risk_profile {
          updated_at
          value
          __typename
        }
        experience {
          experience_stocks {
            updated_at
            value
            __typename
          }
          experience_bonds {
            updated_at
            value
            __typename
          }
          experience_re {
            updated_at
            value
            __typename
          }
          experience_alts {
            updated_at
            value
            __typename
          }
          migrated {
            updated_at
            value
            __typename
          }
          __typename
        }
        employment {
          employment_status
          occupation {
            updated_at
            value
            __typename
          }
          employer {
            updated_at
            value
            __typename
          }
          employer_address {
            updated_at
            value
            __typename
          }
          employer_address2 {
            updated_at
            value
            __typename
          }
          employer_city {
            updated_at
            value
            __typename
          }
          employer_state {
            updated_at
            value
            __typename
          }
          employer_zip {
            updated_at
            value
            __typename
          }
          __typename
        }
        __typename
      }
      claims_is_accredited
      has_bd_account
      aml_date
      aml_status
      kyc_status
      kyc_aml {
        passed_aml
        passed_kyc
        __typename
      }
      created_at
      created_ip_address
      pending_trades {
        id
        subscription_offer {
          id
          listed_at
          slug
          name
          display_name
          entity_name
          description
          offering_id
          status
          auto_invest_doc_v2_id
          auto_invest_doc_v2 {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          documents {
            title
            url
            show_on_listing
            show_on_checkout
            __typename
          }
          current_apy
          expected_return
          regulatory_rule_type
          offer_type
          asset_class
          investor_count {
            settled
            pending
            total
            __typename
          }
          subscription_doc {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          raised_amount {
            settled
            pending
            total
            __typename
          }
          funding_limit
          target_amount
          require_whole_shares
          min_invest_amount
          max_invest_amount
          share_price
          suggested_invest_amounts
          leverage_pct
          non_accredited_slots_full
          sfr {
            documents {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            offering_breakdown {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            volatility
            info {
              address
              city
              state
              zip
              baths
              beds
              description
              electricity
              gas_type
              headline
              images {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              lat_long {
                lat
                long
                __typename
              }
              lot_size
              name
              nearby_employers {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              nearby_schools {
                description
                name
                number_of_reviews
                link
                review_rating
                students
                __typename
              }
              nearby_stores {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              septic
              sewer
              sqft
              tags
              water
              year
              __typename
            }
            market_data {
              projected_dividend_yield
              dividend_yield_historical_average
              dividend_yield_national_average
              dividend_yield_link
              projected_equity_rate
              equity_historical_average
              equity_national_average
              equity_link
              summary
              __typename
            }
            status {
              status
              road_map {
                step
                description
                __typename
              }
              tenant_leasing {
                link
                data {
                  description
                  highlight
                  title
                  link
                  image {
                    url
                    title
                    description
                    link
                    file {
                      bucket
                      key
                      region
                      download_url
                      upload_url
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              updates {
                date
                title
                description
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          total_shares
          auto_invest_doc_id
          auto_invest_doc {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          hints
          __typename
        }
        principal
        created_at
        opened_at
        is_drip
        redemption {
          requested_amount
          redeem_all
          requested_date
          __typename
        }
        scheduled_closing_at
        settled_at
        status
        shares
        share_price
        type
        auto_invest {
          day
          __typename
        }
        rr_suitability_approval {
          approved_by
          approved_at
          updated_at
          approval_status
          snooze_until
          __typename
        }
        principal_suitability_approval {
          approved_by
          updated_at
          approval_status
          snooze_until
          __typename
        }
        goal_id
        __typename
      }
      was_invited
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      rr_suitability_notes {
        created_at
        author
        note
        __typename
      }
      referral_program {
        enrolled_at
        referral_count
        rewards_earned
        branch_link
        referrer_name
        referee_amount
        referee_completed_at
        __typename
      }
      rewards_balance
      tally_dividends
      tally_rewards_earned
      tally_rewards_applied
      is_name_locked
      promos {
        code
        name
        start_date
        end_date
        __typename
      }
      pricing_plan
      accepted_tc_at
      unaccepted_agreements
      partner {
        partner_id
        name
        style {
          primary_logo {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          secondary_logo {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          bg_color
          html
          __typename
        }
        __typename
      }
      hints {
        code
        status
        severity
        text
        __typename
      }
      __typename
    }
    extra_info {
      is_accredited
      original_kyc_aml_info
      signed_doc_url
      __typename
    }
    subscription {
      auto_invest_signature {
        method
        signed_at
        internalsign_details {
          id
          user_id
          investor_account_id
          signed_at
          user_full_name
          file {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          __typename
        }
        __typename
      }
      subscription_offer_id
      subscription_offer {
        id
        listed_at
        slug
        name
        display_name
        entity_name
        description
        offering_id
        status
        auto_invest_doc_v2_id
        auto_invest_doc_v2 {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        documents {
          title
          url
          show_on_listing
          show_on_checkout
          __typename
        }
        current_apy
        expected_return
        regulatory_rule_type
        offer_type
        asset_class
        investor_count {
          settled
          pending
          total
          __typename
        }
        subscription_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        raised_amount {
          settled
          pending
          total
          __typename
        }
        funding_limit
        target_amount
        require_whole_shares
        min_invest_amount
        max_invest_amount
        share_price
        suggested_invest_amounts
        leverage_pct
        non_accredited_slots_full
        sfr {
          documents {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          offering_breakdown {
            link
            data {
              description
              highlight
              title
              link
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          volatility
          info {
            address
            city
            state
            zip
            baths
            beds
            description
            electricity
            gas_type
            headline
            images {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            lat_long {
              lat
              long
              __typename
            }
            lot_size
            name
            nearby_employers {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            nearby_schools {
              description
              name
              number_of_reviews
              link
              review_rating
              students
              __typename
            }
            nearby_stores {
              url
              title
              description
              link
              file {
                bucket
                key
                region
                download_url
                upload_url
                __typename
              }
              __typename
            }
            septic
            sewer
            sqft
            tags
            water
            year
            __typename
          }
          market_data {
            projected_dividend_yield
            dividend_yield_historical_average
            dividend_yield_national_average
            dividend_yield_link
            projected_equity_rate
            equity_historical_average
            equity_national_average
            equity_link
            summary
            __typename
          }
          status {
            status
            road_map {
              step
              description
              __typename
            }
            tenant_leasing {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            updates {
              date
              title
              description
              image {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        total_shares
        auto_invest_doc_id
        auto_invest_doc {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        hints
        __typename
      }
      signature {
        method
        sent_at
        signed_at
        __typename
      }
      total_shares
      cost_basis
      tally_primary_cost
      tally_dividends
      tally_drip_cost
      share_price
      value {
        pending_value
        settled_value
        total_value
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TradesPendingApprovalQueryVariables,
  APITypes.TradesPendingApprovalQuery
>;
export const getPendingManualKYCAMLReviews = /* GraphQL */ `query GetPendingManualKYCAMLReviews {
  getPendingManualKYCAMLReviews {
    investor_account {
      id
      name
      email
      email_verified_at
      email2
      phone
      phone2
      address
      address2
      city
      state
      zip
      country
      status
      individual_details {
        account_type
        first_name
        last_name
        dob
        middle_name
        owners_accredited
        total_assets
        __typename
      }
      employment {
        employment_status
        occupation
        employer
        employer_address
        employer_address2
        employer_city
        employer_state
        employer_zip
        __typename
      }
      domicile
      needs_manual_kyc_aml_review
      manual_kyc_aml_review {
        photo_id_front_file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        photo_id_back_file {
          bucket
          key
          region
          download_url
          upload_url
          __typename
        }
        submitted_at
        completed_at
        __typename
      }
      accreditation {
        started_at
        accredited_on
        method
        status
        docusign_details {
          signer_name
          signer_email
          __typename
        }
        hellosign_details {
          signer_name
          signer_email
          __typename
        }
        __typename
      }
      accreditation_self {
        status
        created_at
        accredited_at
        reason_annual_income
        reason_net_worth
        reason_certification
        reason_employment
        __typename
      }
      accreditation_hellosign {
        status
        created_at
        accredited_at
        signature_details {
          signer_name
          signer_email
          __typename
        }
        __typename
      }
      accreditation_manual {
        status
        created_at
        accredited_at
        __typename
      }
      accredited_survey {
        date_submitted
        __typename
      }
      non_accredited_survey {
        date_submitted
        __typename
      }
      non_accredited_survey_v2 {
        completed_at
        broker_dealer_assoc {
          updated_at
          value
          __typename
        }
        annual_income {
          updated_at
          value
          __typename
        }
        net_worth {
          updated_at
          value
          __typename
        }
        objective {
          updated_at
          value
          __typename
        }
        pct_liquid_securities {
          updated_at
          value
          __typename
        }
        pct_illiquid_securities {
          updated_at
          value
          __typename
        }
        time_horizon {
          updated_at
          value
          __typename
        }
        risk_profile {
          updated_at
          value
          __typename
        }
        experience {
          experience_stocks {
            updated_at
            value
            __typename
          }
          experience_bonds {
            updated_at
            value
            __typename
          }
          experience_re {
            updated_at
            value
            __typename
          }
          experience_alts {
            updated_at
            value
            __typename
          }
          migrated {
            updated_at
            value
            __typename
          }
          __typename
        }
        employment {
          employment_status
          occupation {
            updated_at
            value
            __typename
          }
          employer {
            updated_at
            value
            __typename
          }
          employer_address {
            updated_at
            value
            __typename
          }
          employer_address2 {
            updated_at
            value
            __typename
          }
          employer_city {
            updated_at
            value
            __typename
          }
          employer_state {
            updated_at
            value
            __typename
          }
          employer_zip {
            updated_at
            value
            __typename
          }
          __typename
        }
        __typename
      }
      claims_is_accredited
      has_bd_account
      aml_date
      aml_status
      kyc_status
      kyc_aml {
        passed_aml
        passed_kyc
        __typename
      }
      created_at
      created_ip_address
      pending_trades {
        id
        subscription_offer {
          id
          listed_at
          slug
          name
          display_name
          entity_name
          description
          offering_id
          status
          auto_invest_doc_v2_id
          auto_invest_doc_v2 {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          documents {
            title
            url
            show_on_listing
            show_on_checkout
            __typename
          }
          current_apy
          expected_return
          regulatory_rule_type
          offer_type
          asset_class
          investor_count {
            settled
            pending
            total
            __typename
          }
          subscription_doc {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          raised_amount {
            settled
            pending
            total
            __typename
          }
          funding_limit
          target_amount
          require_whole_shares
          min_invest_amount
          max_invest_amount
          share_price
          suggested_invest_amounts
          leverage_pct
          non_accredited_slots_full
          sfr {
            documents {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            offering_breakdown {
              link
              data {
                description
                highlight
                title
                link
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            volatility
            info {
              address
              city
              state
              zip
              baths
              beds
              description
              electricity
              gas_type
              headline
              images {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              lat_long {
                lat
                long
                __typename
              }
              lot_size
              name
              nearby_employers {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              nearby_schools {
                description
                name
                number_of_reviews
                link
                review_rating
                students
                __typename
              }
              nearby_stores {
                url
                title
                description
                link
                file {
                  bucket
                  key
                  region
                  download_url
                  upload_url
                  __typename
                }
                __typename
              }
              septic
              sewer
              sqft
              tags
              water
              year
              __typename
            }
            market_data {
              projected_dividend_yield
              dividend_yield_historical_average
              dividend_yield_national_average
              dividend_yield_link
              projected_equity_rate
              equity_historical_average
              equity_national_average
              equity_link
              summary
              __typename
            }
            status {
              status
              road_map {
                step
                description
                __typename
              }
              tenant_leasing {
                link
                data {
                  description
                  highlight
                  title
                  link
                  image {
                    url
                    title
                    description
                    link
                    file {
                      bucket
                      key
                      region
                      download_url
                      upload_url
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              updates {
                date
                title
                description
                image {
                  url
                  title
                  description
                  link
                  file {
                    bucket
                    key
                    region
                    download_url
                    upload_url
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          total_shares
          auto_invest_doc_id
          auto_invest_doc {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          hints
          __typename
        }
        principal
        created_at
        opened_at
        is_drip
        redemption {
          requested_amount
          redeem_all
          requested_date
          __typename
        }
        scheduled_closing_at
        settled_at
        status
        shares
        share_price
        type
        auto_invest {
          day
          __typename
        }
        rr_suitability_approval {
          approved_by
          approved_at
          updated_at
          approval_status
          snooze_until
          __typename
        }
        principal_suitability_approval {
          approved_by
          updated_at
          approval_status
          snooze_until
          __typename
        }
        goal_id
        __typename
      }
      was_invited
      rr_suitability_approval {
        approved_by
        approved_at
        updated_at
        approval_status
        snooze_until
        __typename
      }
      rr_suitability_notes {
        created_at
        author
        note
        __typename
      }
      referral_program {
        enrolled_at
        referral_count
        rewards_earned
        branch_link
        referrer_name
        referee_amount
        referee_completed_at
        __typename
      }
      rewards_balance
      tally_dividends
      tally_rewards_earned
      tally_rewards_applied
      is_name_locked
      promos {
        code
        name
        start_date
        end_date
        __typename
      }
      pricing_plan
      accepted_tc_at
      unaccepted_agreements
      partner {
        partner_id
        name
        style {
          primary_logo {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          secondary_logo {
            bucket
            key
            region
            download_url
            upload_url
            __typename
          }
          bg_color
          html
          __typename
        }
        __typename
      }
      hints {
        code
        status
        severity
        text
        __typename
      }
      __typename
    }
    photo_id_front_uri
    photo_id_back_uri
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPendingManualKYCAMLReviewsQueryVariables,
  APITypes.GetPendingManualKYCAMLReviewsQuery
>;
export const getInvestorYearStats = /* GraphQL */ `query GetInvestorYearStats($investor_account_id: ID!) {
  getInvestorYearStats(investor_account_id: $investor_account_id) {
    account_join_date
    yearly_details {
      year
      bonus_payout_percent
      bonus_payout_percentile
      ending_balance
      ending_balance_percentile
      investment_count
      investment_count_percentile
      investment_sum
      investment_sum_percentile
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvestorYearStatsQueryVariables,
  APITypes.GetInvestorYearStatsQuery
>;
export const getInvestorTaxDocuments = /* GraphQL */ `query GetInvestorTaxDocuments($investor_account_id: ID!) {
  getInvestorTaxDocuments(investor_account_id: $investor_account_id) {
    tax_period
    forms {
      form_code
      suffix
      document_file {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvestorTaxDocumentsQueryVariables,
  APITypes.GetInvestorTaxDocumentsQuery
>;
export const getTaxDocumentPresignedURL = /* GraphQL */ `query GetTaxDocumentPresignedURL(
  $investor_account_id: ID!
  $tax_period: Int!
  $form_code: String!
  $suffix: String!
) {
  getTaxDocumentPresignedURL(
    investor_account_id: $investor_account_id
    tax_period: $tax_period
    form_code: $form_code
    suffix: $suffix
  ) {
    download_url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaxDocumentPresignedURLQueryVariables,
  APITypes.GetTaxDocumentPresignedURLQuery
>;
export const getRedemptionPreflightInfo = /* GraphQL */ `query GetRedemptionPreflightInfo(
  $investor_account_id: ID!
  $subscription_offer_id: ID!
) {
  getRedemptionPreflightInfo(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
  ) {
    full_value
    redeemable_value
    time_restricted_value
    goal_restricted_value
    next_scheduled_date
    pending_investments
    pending_redemptions
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRedemptionPreflightInfoQueryVariables,
  APITypes.GetRedemptionPreflightInfoQuery
>;
export const getInvestPreflightInfo = /* GraphQL */ `query GetInvestPreflightInfo(
  $investor_account_id: ID!
  $subscription_offer_id: ID!
  $amount: Int!
) {
  getInvestPreflightInfo(
    investor_account_id: $investor_account_id
    subscription_offer_id: $subscription_offer_id
    amount: $amount
  ) {
    hints
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvestPreflightInfoQueryVariables,
  APITypes.GetInvestPreflightInfoQuery
>;
export const getGoal = /* GraphQL */ `query GetGoal($investor_account_id: ID!, $goal_id: ID!) {
  getGoal(investor_account_id: $investor_account_id, goal_id: $goal_id) {
    investor_account_id
    goal_id
    goal_type
    name
    start_date
    target_date
    target_value
    target_monthly_income
    color
    icon
    current_value
    is_advised
    calculated_monthly_amount
    is_on_track
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGoalQueryVariables, APITypes.GetGoalQuery>;
export const listGoals = /* GraphQL */ `query ListGoals($investor_account_id: ID!) {
  listGoals(investor_account_id: $investor_account_id) {
    investor_account_id
    goal_id
    goal_type
    name
    start_date
    target_date
    target_value
    target_monthly_income
    color
    icon
    current_value
    is_advised
    calculated_monthly_amount
    is_on_track
    __typename
  }
}
` as GeneratedQuery<APITypes.ListGoalsQueryVariables, APITypes.ListGoalsQuery>;
export const getGoalHistory = /* GraphQL */ `query GetGoalHistory($investor_account_id: ID!, $goal_id: ID!) {
  getGoalHistory(investor_account_id: $investor_account_id, goal_id: $goal_id) {
    date
    value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGoalHistoryQueryVariables,
  APITypes.GetGoalHistoryQuery
>;
export const waitlistLookupEmail = /* GraphQL */ `query WaitlistLookupEmail($email: String!) {
  waitlistLookupEmail(email: $email) {
    email
    referral_code
    has_access
    position
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WaitlistLookupEmailQueryVariables,
  APITypes.WaitlistLookupEmailQuery
>;
export const waitlistGetPosition = /* GraphQL */ `query WaitlistGetPosition($code: String!) {
  waitlistGetPosition(code: $code) {
    email
    referral_code
    has_access
    position
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WaitlistGetPositionQueryVariables,
  APITypes.WaitlistGetPositionQuery
>;
export const waitlistListContacts = /* GraphQL */ `query WaitlistListContacts($access_filter: WaitListAccessFilter, $limit: Int!) {
  waitlistListContacts(access_filter: $access_filter, limit: $limit) {
    items {
      email
      user_id
      investor_account_id
      referral_code
      has_access
      position
      __typename
    }
    next_token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WaitlistListContactsQueryVariables,
  APITypes.WaitlistListContactsQuery
>;
export const allPartners = /* GraphQL */ `query AllPartners {
  allPartners {
    partner_id
    name
    style {
      primary_logo {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      secondary_logo {
        bucket
        key
        region
        download_url
        upload_url
        __typename
      }
      bg_color
      html
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllPartnersQueryVariables,
  APITypes.AllPartnersQuery
>;
export const getMonthlyStatement = /* GraphQL */ `query GetMonthlyStatement($investor_account_id: ID!, $month_ym: String!) {
  getMonthlyStatement(
    investor_account_id: $investor_account_id
    month_ym: $month_ym
  ) {
    holdings {
      items {
        subscription_offer_name
        type
        start_shares
        end_shares
        end_share_price
        end_value
        __typename
      }
      totals {
        start_value
        end_value
        __typename
      }
      __typename
    }
    activity {
      trades {
        items {
          date
          subscription_offer_name
          description
          share_price
          shares
          amount
          __typename
        }
        totals {
          amount
          __typename
        }
        __typename
      }
      earnings {
        items {
          date
          subscription_offer_name
          type
          rewards_applied
          net_amount
          __typename
        }
        totals {
          rewards_applied
          net_amount
          __typename
        }
        __typename
      }
      rewards {
        items {
          date
          description
          amount
          end_balance
          __typename
        }
        totals {
          start_balance
          end_balance
          __typename
        }
        __typename
      }
      fees {
        items {
          date
          description
          fee_amount
          __typename
        }
        totals {
          fee_amount
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonthlyStatementQueryVariables,
  APITypes.GetMonthlyStatementQuery
>;
export const bdListSubscriptionOffers = /* GraphQL */ `query BdListSubscriptionOffers {
  bdListSubscriptionOffers {
    id
    display_name
    entity_name
    offering_id
    status
    closings_to_export
    last_closing_date
    total_closings
    total_dollars
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BdListSubscriptionOffersQueryVariables,
  APITypes.BdListSubscriptionOffersQuery
>;
export const bdListSubscriptionOfferClosings = /* GraphQL */ `query BdListSubscriptionOfferClosings($subscription_offer_id: ID!) {
  bdListSubscriptionOfferClosings(
    subscription_offer_id: $subscription_offer_id
  ) {
    subscription_offer_id
    closing_at
    display_name
    entity_name
    offering_id
    total_dollars
    drip_amount
    num_trades
    bd_exported_at
    skip_bd_export
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BdListSubscriptionOfferClosingsQueryVariables,
  APITypes.BdListSubscriptionOfferClosingsQuery
>;
